import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "../services/auth/auth.service";

@Injectable({
	providedIn: 'root'
})
export class AdminGuard  {
	constructor(private authService: AuthService, private router: Router) {}
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const url: string = state.url;
		return this.authService.authorize(true).then(result => {
			if (!result) {
				this.authService.redirectUrl = url;
				return this.router.parseUrl('/home');
			}
			return true;
		});
	}
}
